import React from "react";

const CTASection = ({ onPrimaryClick }) => (
  <section className="provider-beta__cta">
    <h2 className="provider-beta__cta-title">Help Shape the Future of Structured Reflection</h2>
    <p className="provider-beta__cta-body">
      We&apos;re looking for thoughtful professionals who believe people need support between
      sessions—not just during them.
    </p>
    <button type="button" className="primary-button provider-beta__cta-button" onClick={onPrimaryClick}>
      Apply as Provider Beta User
    </button>
  </section>
);

export default CTASection;
